export default __webpack_public_path__ + "static/media/sycamore3.439c2707.jfif";